import { Box, Button, Stack, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { aspectRatio } from 'utils/styles.utils';

import { useGenericClick } from 'services/datalayer/browse';
import { VenueFragment } from 'types/api/dato-operations.types';

import DatoImage from 'components/@common/DatoImage';
import LinkUnstyled from 'components/@common/LinkUnstyled';

interface Props {
  venue: VenueFragment;
}

const VenueCard = ({ venue }: Props) => {
  const handleGenericClick = useGenericClick();
  const address = [
    venue.streetAddress,
    venue.addressRegion,
    venue.postalCode,
    venue.addressCountry,
  ]
    .filter((value) => !!value)
    .join(', ');

  const hasDirectionsUrl = !!venue.directionsUrl;
  const directionUrlProps = hasDirectionsUrl
    ? {
        component: LinkUnstyled,
        href: venue.directionsUrl,
        target: '_blank',
        rel: 'noopener noreferrer',
      }
    : {};

  return (
    <Stack spacing={{ xs: 2, md: 2 }}>
      <Box
        sx={{
          width: '100%',
          position: 'relative',
          overflow: 'hidden',
          borderRadius: 4,
          ...aspectRatio(16, 9),
        }}
      >
        <DatoImage
          data={venue.media}
          fill
          priority
          sizes="(max-width: 900px) 384px, 750px"
          style={{ objectFit: 'cover' }}
        />
      </Box>
      <Stack spacing={0.5}>
        <Typography variant="h5" component="h3">
          {venue.name}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mb: 2,
          }}
        >
          {address}
        </Typography>
      </Stack>
      {hasDirectionsUrl && (
        <Box
          sx={{
            justifyContent: 'flex-start',
          }}
        >
          <Button
            {...directionUrlProps}
            variant="text"
            onClick={() => handleGenericClick({ clickItem: 'Directions' })}
          >
            <FormattedMessage id="event.venue.direction.cta" />
          </Button>
        </Box>
      )}
    </Stack>
  );
};

export default VenueCard;
